import { useEffect, useRef, useState } from 'react';

export function useStaggeredRevealByTwo({
  total,
  threshold = 0.1,
  offsetBottom = 0,
}) {
  const ref = useRef(null);
  const [entered, setEntered] = useState(false);

  useEffect(() => {
    if (!ref.current) return;

    const obs = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setEntered(true);
        } else if (entry.intersectionRatio === 0) {
          setEntered(false);
        }
      },
      {
        threshold,
        rootMargin: `0px 0px -${offsetBottom}px 0px`,
      }
    );

    obs.observe(ref.current);
    return () => obs.disconnect();
  }, [threshold, offsetBottom, total]);

  return { ref, entered };
}
